module.exports = __webpack_public_path__ + "static/media/advance-filter.d6d622dd.svg";